import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  GLOBAL_STATE,
  JOB_POSITION_ACTIVATE,
  JOB_POSITION_ALL,
  JOB_POSITION_CREATE,
  JOB_POSITION_LIST,
} from '../constants/actionTypes'

const jobPositionSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const jobPositionActivateSelector = createSelector(jobPositionSelector, data => data[JOB_POSITION_ACTIVATE])

export const jobPositionAllSelector = createSelector(jobPositionSelector, data => data[JOB_POSITION_ALL])

export const jobPositionCreateSelector = createSelector(jobPositionSelector, data => data[JOB_POSITION_CREATE])

export const jobPositionListSelector = createSelector(jobPositionSelector, data => data[JOB_POSITION_LIST])
